import React from 'react';
import { motion } from 'framer-motion';

interface GameCardProps {
  title: string;
  description: string;
  imageUrl: string;
}

const GameCard: React.FC<GameCardProps> = ({ title, description, imageUrl }) => {
  return (
    <motion.div 
      className="bg-white rounded-xl overflow-hidden shadow-lg"
      whileHover={{ scale: 1.03 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <div className="h-48 overflow-hidden">
        <img 
          src={imageUrl} 
          alt={title} 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-4">
        <h3 className="text-xl font-display font-bold text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4 font-body">{description}</p>
      </div>
    </motion.div>
  );
};

export default GameCard;